<footer class="footer">
  <div *ngIf="this.appComponent.guest" class="solicit-login">
    <p>Only Authorized Users are Allowed to Submit Files</p>
    <p>Please <a style="cursor: pointer;" (click)="this.appComponent.login()">Login</a> or <a href="mailto:donorlabservices@nmdp.org">Request Login ID</a></p>
  </div>
</footer>
  <div class="footer-container">
    <div class="footer-left">
      <p class="build-version">Version: @project.version@</p>
      <p class="copyright">National Marrow Donor Program &#8211; Entrusted to operate the C.W. Bill Young Cell
        Transplantation Program.</p>
    </div>
    <div class="footer-right">
      <ul class="terms-of-use-links">
        <li><a href="https://bethematch.org/terms-of-use" target="_blank" rel="noopener noreferrer">Terms of use</a></li>
        <li class="separator"></li>
        <li><a href="https://bethematch.org/privacy" target="_blank" rel="noopener noreferrer">Privacy policy</a></li>
        <li class="separator"></li>
        <li><a href="https://bethematch.org/about-us/careers/working-with-us" target="_blank" rel="noopener noreferrer">EEO/Affirmative Action
          Employer</a></li>
      </ul>
      <p class="copyright">Copyright &copy; {{currentYear}} National Marrow Donor Program. All Rights Reserved.</p>
    </div>
  </div>

